import format from "date-fns/format";

export function formatArticleDate(unixTimestamp) {
  if (unixTimestamp) {
    const publishedDate = new Date(unixTimestamp * 1000);
    try {
      return format(publishedDate, "MMM d, yyyy");
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error, { publishedDate });
    }
  }
  return "";
}
